import React from 'react';
import styled from 'styled-components';

import { Button } from '@monolith/components/0-atoms/Button';
import Icon from '@monolith/components/0-atoms/Icon';
import { InfoBox, Typography } from '@opus1/harmony';
import {
    STAFF_IMPORT_PAGE_COPY,
    deriveStaffImportCompleteSummary,
} from '../constants/staffImport';
import type { ProcessResult } from '../types/staffImport';

export interface StaffImportCompletePanelProps {
    result: ProcessResult;
    onImportAnother: () => void;
    onRetryFailed: () => void;
}

const Panel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 32px 64px 48px;
    max-width: 960px;
`;

export const StaffImportCompletePanel: React.FC<
    StaffImportCompletePanelProps
> = ({ result, onImportAnother, onRetryFailed }) => {
    const summary = deriveStaffImportCompleteSummary(result);
    const failures = result.results.filter(
        (rowResult) => rowResult.status === 'failed',
    );

    return (
        <Panel>
            <Typography variant="title" weight={700} as="h1">
                {summary.title}
            </Typography>
            <InfoBox variant={summary.variant}>{summary.message}</InfoBox>
            {failures.length > 0 ? (
                <>
                    <ul>
                        {failures.map((failure) => (
                            <li key={failure.rowId}>
                                {failure.rowId}: {failure.error}
                            </li>
                        ))}
                    </ul>
                    <Button
                        id="staff-import-retry-failed"
                        variant="accent-secondary"
                        size="large"
                        onClick={onRetryFailed}
                    >
                        Retry failed rows
                    </Button>
                </>
            ) : null}
            <Button
                id="staff-import-another-file"
                variant="secondary"
                size="large"
                onClick={onImportAnother}
            >
                <Icon farIcon="file-import" className="mr-2" />
                {STAFF_IMPORT_PAGE_COPY.importAnotherFileLabel}
            </Button>
        </Panel>
    );
};

export default StaffImportCompletePanel;
